import { UserGroup } from '../../contexts'

const unrestrictedScanRoles = [
  UserGroup.BrandProtection,
  UserGroup.Admin,
  UserGroup.SuperAdmin,
  UserGroup.Warehouse,
  UserGroup.WarehouseExtended,
  UserGroup.Franchise,
]

const restrictedScanRoles = [UserGroup.Distributor]

const pageRoleGroups = {
  newScan: unrestrictedScanRoles,
  scan: [...unrestrictedScanRoles, ...restrictedScanRoles],
  upload: [
    UserGroup.BrandProtection,
    UserGroup.Distributor,
    UserGroup.Admin,
    UserGroup.SuperAdmin,
    UserGroup.Warehouse,
    UserGroup.WarehouseExtended,
  ],
  trace: [
    UserGroup.BrandProtection,
    UserGroup.BrandProtectionExtended,
    UserGroup.Admin,
    UserGroup.SuperAdmin,
    UserGroup.WarehouseExtended,
    UserGroup.Retail,
  ],
  'batch-numbers': [UserGroup.Admin, UserGroup.SuperAdmin],
  'authentic-check': [
    UserGroup.BrandProtection,
    UserGroup.BrandProtectionExtended,
    UserGroup.Admin,
    UserGroup.SuperAdmin,
    UserGroup.Retail,
  ],
  manual: [UserGroup.Distributor],
  'generate-serials': [UserGroup.SuperAdmin],
}

export default pageRoleGroups
